module.exports = __webpack_public_path__ + "img/1493590087.499e95ec.jpg";